import { FC } from 'react';
import EditIcon from '../../../../assets/images/svg/EditIcon';
import { classNames } from '../../../utils';

type EditButtonProps = {
  disabled?: boolean;
  onClick: () => void;
};

const EditButton: FC<EditButtonProps> = ({ onClick, disabled = false }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={classNames(
        'focus:outline-none px-2 outline-none py-2 flex flex-row justify-center',
        disabled
          ? 'text-gray-light cursor-default'
          : 'text-gray-dark cursor-pointer',
      )}
    >
      <EditIcon />
    </button>
  );
};

export default EditButton;
